import { create } from "zustand";
import { JobSlice, createJobStore } from "./job.store";

interface JobStoreTypes extends JobSlice {}

export const useJobStore = create<JobStoreTypes>((...args) => ({
	...createJobStore(...args),
}));
